<ion-item *ngIf="showItem" button (click)="onSignInOut()" detail>
  <ion-icon [name]="isSignedIn ? 'log-out-sharp' : 'log-in-sharp'" slot="start"/>
  <ion-label>{{ isSignedIn ? 'Sign Out' : 'Sign In' }}</ion-label>
  <ion-toggle
    class="small-toggle"
    *ngIf="showToggle"
    (click)="togglePrompt($event)"
    slot="end"
    justify="start"
  >Prompt
  </ion-toggle>
</ion-item>
